import * as faqs from './faqs'

const subdomain = location.pathname.indexOf( "clinic-alpha" ) > -1 ? "clinic-alpha" : "clinic"

// ---------------------------------------------------
// Find current view (look-around assertions)
// and set view to persist reload
// e.g https://epha.ch/clinic/case/?id=234sdafasdf/de/
// ---------------------------------------------------
export function view( pathname ) {
  // ['clinic', view-something, lang ]
  const { view } = parse( pathname )
  // View needs to be set explicitly otherwise try to start
  if ( view == "error" ) {
    return "start"
  }
  // Helper
  return view || "start"
}

// --------------------------
// Find default language
// --------------------------
export function lang( pathname ) {

  const { lang } = parse( pathname )

  let language = lang || ""

  if ( !language && navigator.userLanguage ) {
    language = navigator.userLanguage.split( "-" )[ 0 ]
  }
  if ( !language && navigator.languages && navigator.languages.length > 0 ) {
    language = navigator.languages[ 0 ].split( "-" )[ 0 ]
  }
  if ( !language && navigator.language ) {
    language = navigator.language.split( "-" )[ 0 ]
  }
  if ( !language ) {
    language = "de"
  }

  return language

}

// -----------------------------------
// Parse pathname and always
// return object
// -----------------------------------
export function parse( pathname ) {

  // Ensure value
  pathname = pathname || location.pathname
  // Parse pathname with base or as href
  pathname = ( new URL( pathname, location.origin ) ).pathname
  // Tokenize
  const extras = pathname.split( "/" ).filter( p => !!p )
  const params = {}
  // Find view and don't accept errornous language
  if ( extras.length >= 2 && extras[ 1 ].length > 2 ) {
    params[ "view" ] = extras[ 1 ]
  }
  // Find language
  const langs = [ "de", "fr", "it", "en", "es", "ru", "zh", "pt" ]
  if ( extras.length >= 3 && langs.includes( extras[ 2 ] ) ) {
    params[ "lang" ] = extras[ 2 ]
  }
  // Find data
  for ( const extra of extras ) {
    if ( extra.indexOf( "for-drug-" ) == 0 ) {
      // e.g. acetylsalicyls%C3%A4ure
      const drugs = extra.slice( 9 ).split( "-" ).filter( d => !!d )
      params[ "drugs" ] = drugs.map( decodeURI )
    }
    if ( extra.indexOf( "and-" ) == 0 ) {
      const ikvs = extra.slice( 4 ).split( "-" ).filter( f => !!f )
      params[ "faqs" ] = faqs.decode( ikvs )
    }
    if ( extra.indexOf( "xid=" ) == 0 ) {
      params[ "xid" ] = extra.slice( 4 )
    }
  }

  return params
}

export function build( view, lang, xeon ) {

  if ( view != "advice" ) {
    // Keep hash or clean if new viwe
    return `/${subdomain}/${view}/${lang}/`
  }

  var extras = ""

  if ( xeon.drugs && Object.keys( xeon.drugs ).length ) {
    extras += `for-drug-${Object.keys(xeon.drugs).join("-")}/`
  }

  if ( xeon.faqs && Object.keys( xeon.faqs ).length ) {
    const list = faqs.encode( xeon.faqs )
    if ( list.length > 0 ) {
      extras += `and-${list.join("-")}/`
    }
  }

  return `/${subdomain}/${view}/${lang}/${extras}`

}

export function share( xeon ) {

  // Construct url
  const { origin, pathname } = location
  const { view, lang } = parse( pathname )
  const url = `${origin}/${subdomain}/${view}/${lang}/xid=${xeon.id}/`
  // console.log(url)
  return url

}